import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  Country: {
    to: 'CountryLookupUI',
  },
  Currency: {
    to: 'CurrencyLookupUI',
  },
  Municipality: {
    to: 'MunicipalityLookupUI',
  },
  ProvinceState: {
    to: 'ProvinceStateLookupUI',
  }
}